import Cookies from 'js-cookie';

/*
 * Add XDID UUID from Cookie on to LYP URL
 */
export function addXdidToElementHref(e) {
  const href = e.target.href;
  if (href.indexOf('xdid') === -1) {
    let xdid = Cookies.get('xdid');
    if (xdid) {
      xdid = (xdid.indexOf('|') === -1) ? xdid : xdid.split('|')[0];
      e.target.href = `${href}${href.indexOf('?') > 0 ? '&' : '?'}xdid=${xdid}`;
    }
  }
}